// extracted by mini-css-extract-plugin
module.exports = {"footerDescription":"CookieTerms_footerDescription__pMKaR","termsEditButton":"CookieTerms_termsEditButton__ZJm76"};